import { TFunction } from 'i18next';

import { MultiColorDisplayOption } from './colorOption';

export const HairToneModelOptions = ['blonde', 'brown', 'black', 'red', 'gray', 'colorful'] as const;
export type HairToneModel = (typeof HairToneModelOptions)[number];

export interface HairToneOption extends MultiColorDisplayOption {
  id: HairToneModel;
}

export const hairToneTitle = (id: HairToneModel, t: TFunction) => {
  switch (id) {
    case 'gray':
      return t('LOC_COLOR_GRAY', { ns: 'model' });
    case 'blonde':
      return t('LOC_COLOR_BLONDE', { ns: 'model' });
    case 'brown':
      return t('LOC_COLOR_BROWN', { ns: 'model' });
    case 'black':
      return t('LOC_COLOR_BLACK', { ns: 'model' });
    case 'red':
      return t('LOC_COLOR_RED', { ns: 'model' });
    case 'colorful':
      return t('LOC_COLOR_COLORFUL', { ns: 'model' });
  }
  throw new Error(`Unhandled option ${id}`);
};

const hexColorMapping: { [x in HairToneModel]: string[] } = {
  gray: ['#F2F2F2', '#D8D8D8', '#B5B2B2'],
  blonde: ['#FAFAD2', '#FBE7A1', '#EAD068'],
  brown: ['#C18344', '#5A3825', '#3D2314'],
  black: ['#3E3E3E', '#313131', '#242424'],
  red: ['#E1621D', '#DC1A3A', '#5E0808'],
  colorful: ['#ECA1AC', '#7584B3', '#4D7253'],
};

export const buildHairToneOptions = (t: TFunction): HairToneOption[] => {
  return HairToneModelOptions.map((id) => {
    const option: HairToneOption = {
      id,
      title: hairToneTitle(id, t),
      hexColors: hexColorMapping[id],
      imagePath: 'hair',
    };
    return option;
  });
};
